module.exports = __webpack_public_path__ + "img/976715d0d3d5790aa600e28fb2d2031e.png";